import React from "react";
import T from "prop-types";

import Priloha from "./Priloha";

export function Prilohy({ files, ...restProps }) {
  return (
    <div className="b2b-Prilohy">
      {files?.map(file => (
        <Priloha key={file.name} file={file} {...restProps} />
      ))}
    </div>
  );
}

Prilohy.propTypes = {
  files: T.array,
  onDelete: T.func,
  onDownload: T.func,
  disabled: T.bool
};

export default React.memo(Prilohy);
